module.exports = __webpack_public_path__ + "media/images/favicon/favicon-1b4304eb54a9a05adbdad06473358d30.ico";